import { IApplicationState } from '../../types/redux';

export function selectOtpModalIsOpen(state: IApplicationState) {
  return state.otpModal.open;
}
